export default {
  setValue(state, { property, data }) {
    state[property] = data;
  },
  setDashboard(state, data) {
    state.results.dashboard = data;
  },
  setPagination(state, data) {
    state.results.pagination = data;
  },
  setItemsResult(state, data) {
    state.results.items = data;
  },
  setCanResearch(state, bool) {
    state.canResearch = bool;
  },
  setAcademicYears(state, data) {
    state.academicYears = data;
  },
  setRegions(state, data) {
    state.regions = data;
  },
  setStatuses(state, data) {
    state.sampleInventoryStatuses = data;
  },
  setDistricts(state, data) {
    state.districts = data;
  },
  setSchools(state, data) {
    state.schools = data;
  },
  reset(state, exclude = []) {
    Object.keys(state).forEach((prop) => {
      if (prop.startsWith('selected') && !exclude.includes(prop)) {
        state[prop] = null;
      }
    });

    state.results = {
      ...state.results,
      items: [],
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
        pageSize: 10,
      },
    };
  },
};
